var _defs, _path, _circle, _path2, _circle2, _path3, _circle3, _path4, _g, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hail",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.689,
    height: 33.689,
    viewBox: "0 0 33.689 33.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.087,
    y1: 1.245,
    x2: -0.047,
    y2: 1.226,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M282.452,416.205l-2.111,2.111a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.082,2.082,0,0,0-.211-.9l2.111-2.111a.7.7,0,1,0-.992-.992Z",
    transform: "translate(-259.085 -388.627)",
    fill: "#303c42"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 0.702,
    cy: 0.702,
    r: 0.702,
    transform: "translate(19.652 30.882)",
    fill: "#bbdefb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M389.82,384.205l-2.813,2.813a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.082,2.082,0,0,0-.211-.9l2.813-2.813a.7.7,0,1,0-.992-.992Z",
    transform: "translate(-358.732 -358.733)",
    fill: "#303c42"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 0.702,
    cy: 0.702,
    r: 0.702,
    transform: "translate(26.671 29.478)",
    fill: "#bbdefb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M90.452,416.205l-2.111,2.111a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.081,2.081,0,0,0-.211-.9l2.111-2.111a.7.7,0,0,0-.992-.992Z",
    transform: "translate(-79.718 -388.627)",
    fill: "#303c42"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 0.702,
    cy: 0.702,
    r: 0.702,
    transform: "translate(7.019 30.882)",
    fill: "#bbdefb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M26.178,19.652h.493a7.019,7.019,0,1,0-1.6-13.835,9.789,9.789,0,0,0-18.687,3,5.613,5.613,0,0,0-3.578,5.219,5.12,5.12,0,0,0,.117,1.006,6.29,6.29,0,0,0,1.9,11.43L3.008,28.286a2.081,2.081,0,0,0-.9-.211A2.106,2.106,0,1,0,4.211,30.18a2.081,2.081,0,0,0-.211-.9l2.607-2.607H17.256l-1.615,1.615a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.081,2.081,0,0,0-.211-.9l2.607-2.607h2.517a4.919,4.919,0,0,0,4.913-4.913A4.857,4.857,0,0,0,26.178,19.652Z",
    fill: "#303c42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482",
    transform: "translate(1.404 29.478)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 0.702,
    cy: 0.702,
    r: 0.702,
    transform: "translate(12.634)",
    fill: "#bbdefb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 0.702,
    cy: 0.702,
    r: 0.702,
    fill: "#bbdefb"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M64,33.967a4.216,4.216,0,0,1,4.211-4.211.7.7,0,1,0,0-1.4,5.5,5.5,0,0,0-.593.06,8.4,8.4,0,0,1,15.907-2.22,6.972,6.972,0,0,0-.982.546.7.7,0,0,0,.784,1.164A5.615,5.615,0,1,1,86.46,38.178H84.974a4.929,4.929,0,0,0-1.4-.951,8.39,8.39,0,0,0-15.758-3,5.839,5.839,0,0,0-3.789.119A3.456,3.456,0,0,1,64,33.967Z",
    transform: "translate(-59.789 -19.929)",
    fill: "#64b5f6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M362.831,111.611a5.605,5.605,0,0,1-4.616,8.8H357.9a8.333,8.333,0,0,1,.24,1.155,4.928,4.928,0,0,1,1.4.951h1.486a5.6,5.6,0,0,0,1.808-10.9Z",
    transform: "translate(-334.351 -104.267)",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M41.687,184.7H26.246a4.913,4.913,0,0,1,0-9.826,4.862,4.862,0,0,1,3.069,1.076.7.7,0,1,0,.877-1.1,6.253,6.253,0,0,0-.92-.609,6.977,6.977,0,0,1,12.949,2.086,4.816,4.816,0,0,0-.534-.054.7.7,0,1,0,0,1.4,3.509,3.509,0,0,1,0,7.019Z",
    transform: "translate(-19.929 -159.436)",
    fill: "#64b5f6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M23.367,27.578l-2.111,2.111a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.081,2.081,0,0,0-.211-.9l2.111-2.111a.7.7,0,0,0-.992-.992Zm7.72-2.106-2.813,2.813a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.081,2.081,0,0,0-.211-.9l2.813-2.813a.7.7,0,0,0-.992-.992ZM10.734,27.578,8.623,29.689a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.081,2.081,0,0,0-.211-.9l2.111-2.111a.7.7,0,0,0-.992-.992Zm15.444-7.926h.493a7.019,7.019,0,1,0-1.6-13.835,9.789,9.789,0,0,0-18.687,3,5.613,5.613,0,0,0-3.578,5.219,5.12,5.12,0,0,0,.117,1.006,6.29,6.29,0,0,0,1.9,11.43L3.008,28.286a2.081,2.081,0,0,0-.9-.211A2.106,2.106,0,1,0,4.211,30.18a2.081,2.081,0,0,0-.211-.9l2.607-2.607H17.256l-1.615,1.615a2.081,2.081,0,0,0-.9-.211,2.106,2.106,0,1,0,2.106,2.106,2.081,2.081,0,0,0-.211-.9l2.607-2.607h2.517a4.919,4.919,0,0,0,4.913-4.913A4.857,4.857,0,0,0,26.178,19.652Z",
    fill: "url(#linear-gradient)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M47.682,287.184a3.491,3.491,0,0,1-3.423,4.265H28.818a4.872,4.872,0,0,1-3.229-1.24,4.9,4.9,0,0,0,4.633,3.346H45.663a3.5,3.5,0,0,0,2.019-6.37Z",
    transform: "translate(-23.905 -268.287)",
    opacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHail);
export default __webpack_public_path__ + "static/media/hail.f73089a6a36d58c2b4e7e11c6bcf5993.svg";
export { ForwardRef as ReactComponent };